import type {MaskitoPostprocessor} from '@maskito/core';
import type {MetadataJson} from 'libphonenumber-js/core';

import {cutPhoneByValidLength} from '../utils';

const MIN_LENGTH = 3;

/**
 * Источник - https://github.com/taiga-family/maskito/blob/main/projects/phone/src/lib/masks/phone/processors/phone-length-postprocessor.ts
 */
export function phoneLengthPostprocessorGenerator(
    metadata: MetadataJson,
): MaskitoPostprocessor {
    return ({value, selection}) => ({
        value:
            value.length > MIN_LENGTH ? cutPhoneByValidLength({phone: value, metadata}) : value,
        selection,
    });
}
